// extracted by mini-css-extract-plugin
module.exports = {"answers":"style_answers__1usy0","answer":"style_answer__HD47d","switch":"style_switch__2KwjD"};